import { v4 as uuidv4 } from "uuid";

const generateId = () => uuidv4();

export { generateId };
